import { client } from '@/lib/api/client'
import { venueDashboardPath } from '@/lib/api/config'
import { toApiError } from '@/lib/api/errors'

import type { VenueDashboardView } from './dashboardTypes'

/**
 * `GET /venue/v1/manager/venues/{venueId}/dashboard` — 구장 대시보드 요약 (#587).
 *
 * 🚨 게이팅 대상이 아니다 — 두 이용권이 모두 만료돼도 항상 200 이다(영구 잠금 방지).
 * 🚨 `reservations`·`cancellations`·`recentReservationAlerts` 는 이 서버 버전에서 항상 `null` 이다.
 * `0`·빈 배열로 기본값 처리하지 말 것 — "미제공"과 "0건"은 다른 사실이다(#587 §0-2).
 */
export async function fetchVenueDashboard(venueId: string): Promise<VenueDashboardView> {
  try {
    const { data } = await client.get<VenueDashboardView>(venueDashboardPath(venueId))
    return data
  } catch (error) {
    throw toApiError(error)
  }
}
